import React from 'react'
import styled from 'styled-components'
import { FiClock } from 'react-icons/fi'
import { PlaceIcon } from '../PlaceIcon/PlaceIcon'
import { Place } from '../PlaceIcon/icons'
export interface JobCardProps {
     time?: string,
     views?: number,
     companyName?: string,
     companyIcon?: Place,
     title?: string,
     jobTime?: string,
     jobCategory?: string
     CompanyImage?: string
}


const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 300px;
    justify-content: space-between;
    background-color: #282828;
    margin: 15px;
    padding: 10px;
    text-align: right;
    transition: background-color 0.2s ease;
    &:hover{
        background-color: black;
    }
`
const Company = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`

const CompanyName = styled.p`
   font-size: 13px;
   color: #BBBBBB;
   padding: 0;
   margin: 0;
   margin-right: 5px;
`

const JobTitle = styled.p`
   font-size: 17px;
   color: #fff;
   padding: 0;
   margin: 5px;
`

const About = styled.p`
    font-size: 14px;
    color: #BBBBBB;
    padding: 0;
    margin: 0;
    margin-right: 5px;
`

const TimeAndViews = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-right: 5px;
  padding-top: 5px;
`

const Time = styled.div`
   display: flex;
   flex-direction: row;
   align-items: center;
`

const TimeText = styled.p`
    font-size: 11px;
    color: #BBBBBB;
    padding: 0;
    margin: 0;
    margin-left: 5px;
`

export const JobCard: React.FC<JobCardProps> = (props) => {

    


    return (
        <CardContainer dir='rtl'>
            <Company>
                <PlaceIcon name={props.companyIcon} url={props.CompanyImage} style={{width: 27, height: 27, padding: 2}} />
                <CompanyName>{props.companyName}</CompanyName>
            </Company>
            <JobTitle>{props.title}</JobTitle>
            <About>{props.jobTime} / {props.jobCategory}</About>
            <TimeAndViews>
                <Time>
                   <FiClock color='#BBBBBB' size={19} style={{marginLeft: 8}} />
                   <TimeText>منذ {props.time}</TimeText>
                </Time>
            </TimeAndViews>
        </CardContainer>
    ) 
}